import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  button: {
    fontWeight: 600,
    fontSize: 16,
    textTransform: 'unset',
    padding: '4px 24px',
    borderRadius: theme.borderRadius.md,
    boxShadow: 'none',

    '&.MuiButton-startIcon': {
      ...dFlex(),
    },

    '&.MuiButton-sizeLarge': {
      height: 44,
    },

    '&.MuiButton-sizeMedium': {
      height: 40,
    },

    '&.MuiButton-sizeSmall': {
      height: 32,
      padding: '4px 16px',
    },

    '&.MuiButton-contained': {
      background: theme.primary.p3,
      color: theme.primary.p2,
      border: '1px solid transparent',

      '&:hover': {
        background: theme.secondary.s4,
        color: theme.primary.p2,
        borderColor: 'transparent',
      },

      '&:focus': {
        color: theme.primary.p2,
        borderColor: theme.primary.p2,
      },

      '&:active': {
        background: theme.primary.p3,
        color: theme.primary.p2,
        borderColor: 'transparent',
      },

      '&:disabled': {
        background: theme.secondary.s1,
        color: theme.secondary.s3,
        borderColor: 'transparent',
        opacity: 0.38,
      },
    },

    '&.MuiButton-textGray': {
      color: theme.secondary.s3,
      background: 'transparent',

      '&.MuiButton-sizeLarge': {
        padding: 4,
        height: 'initial',
      },

      '&.MuiButton-sizeMedium': {
        padding: 4,
        height: 'initial',
      },

      '&.MuiButton-sizeSmall': {
        padding: 4,
        height: 'initial',
      },

      '&:hover': {
        color: theme.primary.p2,
        background: 'transparent',
      },

      '&:active': {
        color: theme.primary.p3,
        background: 'transparent',
      },

      '&:focus': {
        color: theme.primary.p3,
        background: 'transparent',
      },

      '&:disabled': {
        color: theme.primary.p2,
        opacity: 0.32,
        background: 'transparent',
      },
    },

    '&.MuiButton-textBlue': {
      color: theme.primary.p3,
      background: 'transparent',

      '&.MuiButton-sizeLarge': {
        padding: 4,
        height: 'initial',
      },

      '&.MuiButton-sizeMedium': {
        padding: 4,
        height: 'initial',
      },

      '&.MuiButton-sizeSmall': {
        padding: 4,
        height: 'initial',
      },

      '&:hover': {
        color: theme.secondary.s4,
        background: 'transparent',
      },

      '&:active': {
        color: theme.secondary.s4,
        background: 'transparent',
      },

      '&:focus': {
        color: theme.secondary.s4,
        background: 'transparent',
      },

      '&:disabled': {
        background: 'transparent',
        color: theme.primary.p2,
        opacity: 0.32,
      },
    },

    '&.MuiButton-textWhite': {
      color: theme.primary.p2,
      background: 'transparent',

      '&.MuiButton-sizeLarge': {
        padding: 4,
        height: 'initial',
      },

      '&.MuiButton-sizeMedium': {
        padding: 4,
        height: 'initial',
      },

      '&.MuiButton-sizeSmall': {
        padding: 4,
        height: 'initial',
      },

      '&:hover': {
        color: theme.secondary.s4,
        background: 'transparent',
      },

      '&:active': {
        color: theme.secondary.s4,
        background: 'transparent',
      },

      '&:focus': {
        color: theme.secondary.s4,
        background: 'transparent',
      },

      '&:disabled': {
        background: 'transparent',
        color: theme.primary.p2,
        opacity: 0.32,
      },
    },

    '&.MuiButton-secondary': {
      background: theme.secondary.s1,
      color: theme.primary.p2,
      border: '1px solid transparent',

      '&:hover': {
        background: theme.secondary.s4,
        color: theme.primary.p2,
        borderColor: 'transparent',
      },

      '&:focus': {
        background: theme.secondary.s5,
        color: theme.primary.p3,
        borderColor: 'transparent',
      },

      '&:active': {
        background: theme.secondary.s5,
        color: theme.primary.p3,
        borderColor: 'transparent',
      },

      '&:disabled': {
        background: theme.secondary.s5,
        color: theme.primary.p2,
        borderColor: 'transparent',
        opacity: 0.38,

        '&:hover': {
          opacity: 0.38,
          background: theme.secondary.s5,
        },
      },

      '&.Mui-disabled': {
        background: theme.secondary.s5,
        color: theme.primary.p2,
        borderColor: 'transparent',
        opacity: 0.38,

        '&:hover': {
          opacity: 0.38,
          background: theme.secondary.s5,
        },
      },
    },

    '&.MuiButton-clear': {
      background: theme.secondary.s1,
      color: theme.primary.p2,
      border: '1px solid transparent',

      '&:hover': {
        background: theme.secondary.s4,
        color: theme.primary.p2,
        borderColor: 'transparent',
      },

      '&:focus': {
        background: theme.secondary.s5,
        color: theme.primary.p3,
        borderColor: 'transparent',
      },

      '&:active': {
        background: theme.secondary.s5,
        color: theme.primary.p3,
        borderColor: 'transparent',
      },

      '&:disabled': {
        background: theme.secondary.s1,
        color: theme.secondary.s3,
        borderColor: 'transparent',
      },
    },

    '&.MuiButton-secondaryDark': {
      background: theme.secondary.s5,
      color: theme.primary.p2,
      border: '1px solid transparent',

      '&:hover': {
        background: theme.secondary.s4,
        color: theme.primary.p2,
        borderColor: 'transparent',
      },

      '&:focus': {
        background: theme.secondary.s5,
        color: theme.primary.p3,
        borderColor: 'transparent',
      },

      '&:active': {
        background: theme.secondary.s5,
        color: theme.primary.p3,
        borderColor: 'transparent',
      },

      '&:disabled': {
        background: theme.secondary.s5,
        color: theme.primary.p2,
        borderColor: 'transparent',
        opacity: 0.38,
      },
    },

    '&.MuiButton-errorPrimary': {
      background: theme.accent.a6,
      color: theme.primary.p2,
      border: '1px solid transparent',

      '&:hover': {
        background: theme.accent.a6,
        color: theme.accent.a4,
        borderColor: 'transparent',
      },

      '&:focus': {
        background: theme.accent.a6,
        color: theme.primary.p2,
        borderColor: theme.primary.p2,
      },

      '&:active': {
        background: theme.accent.a6,
        color: theme.accent.a4,
        borderColor: 'transparent',
      },

      '&:disabled': {
        background: theme.accent.a6,
        color: theme.primary.p2,
        borderColor: 'transparent',
        opacity: 0.38,
      },
    },

    '&.MuiButton-successPrimary': {
      background: theme.accent.a1,
      color: theme.primary.p2,
      border: '1px solid transparent',

      '&:hover': {
        background: theme.accent.a7,
        color: theme.primary.p2,
        borderColor: 'transparent',
      },

      '&:focus': {
        background: theme.accent.a1,
        color: theme.primary.p2,
        borderColor: theme.primary.p2,
      },

      '&:active': {
        background: theme.accent.a1,
        color: theme.primary.p2,
        borderColor: 'transparent',
      },

      '&:disabled': {
        background: theme.accent.a1,
        color: theme.primary.p2,
        borderColor: 'transparent',
        opacity: 0.38,
      },
    },

    '&.MuiButton-warningPrimary': {
      background: theme.accent.a4,
      color: theme.primary.p2,
      border: '1px solid transparent',

      '&:hover': {
        background: theme.accent.a2,
        color: theme.background.b1,
        borderColor: 'transparent',
      },

      '&:focus': {
        background: theme.accent.a4,
        color: theme.primary.p2,
        borderColor: theme.primary.p2,
      },

      '&:active': {
        background: theme.accent.a4,
        color: theme.primary.p2,
        borderColor: 'transparent',
      },

      '&:disabled': {
        background: theme.accent.a4,
        color: theme.primary.p2,
        borderColor: 'transparent',
        opacity: 0.38,
      },
    },
    '&.MuiButton-squarePrimary': {
      background: theme.secondary.s1,
      color: theme.primary.p2,
      padding: 6,

      '&.MuiButton-sizeSmall': {
        padding: 4,

        '& .MuiSvgIcon-root': {
          color: theme.primary.p2,
          width: 24,
        },
      },

      '&:hover': {
        background: theme.background.b1,
      },

      '&:focus': {
        background: theme.background.b1,
        color: theme.primary.p3,
      },

      '&:active': {
        background: theme.primary.p3,
        color: theme.primary.p2,
      },

      '&:disabled': {
        background: theme.secondary.s5,
        color: theme.primary.p2,
        opacity: 0.38,
      },
    },

    '&.MuiButton-gradientPrimary': {
      background: theme.gradient.g2,

      '&:hover': {
        background: theme.gradient.g3,
      },

      '&:focus': {
        background: theme.gradient.g2,
        outline: `1px solid ${theme.primary.p2}`,
      },

      '&:disabled': {
        color: theme.primary.p2,
        opacity: 0.38,
      },
    },

    '&.MuiButton-range': {
      background: theme.secondary.s5,

      '&:hover': {
        background: theme.secondary.s6,
      },

      '&:focus': {
        background: theme.primary.p3,
      },

      '&:active': {
        background: theme.primary.p3,
      },

      '&:disabled': {
        color: theme.secondary.s2,
        opacity: 0.3,
      },
    },
    '&.MuiButton-circleGrayPrimary': {
      background: theme.secondary.s1,
      color: theme.primary.p2,
      padding: 3,
      borderRadius: theme.borderRadius.xxl,
      height: 30,
      width: 30,

      '& .MuiSvgIcon-root': {
        color: theme.primary.p2,
        width: 24,
        height: 24,
      },

      '&:hover': {
        background: theme.background.b1,
      },

      '&:focus': {
        background: theme.background.b1,
        color: theme.primary.p3,
      },

      '&:active': {
        background: theme.primary.p3,
        color: theme.primary.p2,
      },

      '&:disabled': {
        background: theme.secondary.s1,
        color: theme.primary.p2,
        opacity: 0.38,
      },
    },

    '&.MuiButton-circleDarkPrimary': {
      background: theme.background.b1,
      color: theme.primary.p2,
      padding: 3,
      borderRadius: theme.borderRadius.xxl,
      height: 30,
      width: 30,

      '& .MuiSvgIcon-root': {
        color: theme.primary.p2,
        width: 24,
        height: 24,
      },

      '&:hover': {
        background: theme.secondary.s6,
      },

      '&:focus': {
        background: theme.secondary.s6,
        color: theme.primary.p3,
      },

      '&:active': {
        background: theme.primary.p3,
        color: theme.primary.p2,
      },

      '&:disabled': {
        background: theme.background.b1,
        color: theme.primary.p2,
        opacity: 0.38,
      },
    },
  },
  loading: {
    '& .MuiButton-icon': {
      display: 'none',
    },

    '&.MuiButton-contained': {
      background: theme.primary.p3,
      opacity: 1,
      cursor: 'default',
      boxShadow: 'none',

      '&:hover': {
        background: theme.primary.p3,
      },

      '&:active': {
        background: theme.primary.p3,
        boxShadow: 'none',
      },

      '&:disabled': {
        opacity: 1,
        background: theme.primary.p3,
      },
    },

    '&.MuiButton-outlined': {
      borderColor: theme.primary.p1,

      '.MuiCircularProgress-root.MuiCircularProgress-indeterminate': {
        color: theme.primary.p2,
      },
    },

    '&.MuiButton-secondary': {
      '.MuiCircularProgress-root.MuiCircularProgress-indeterminate': {
        color: theme.primary.p2,
      },

      '&:disabled': {
        background: theme.secondary.s1,
        opacity: 1,
      },
    },

    '&.MuiButton-error': {
      '.MuiCircularProgress-root.MuiCircularProgress-indeterminate': {
        color: theme.primary.p2,
      },

      '&:disabled': {
        background: theme.accent.a6,
        opacity: 1,
      },
    },

    '&.MuiButton-successPrimary': {
      '.MuiCircularProgress-root.MuiCircularProgress-indeterminate': {
        color: theme.primary.p2,
      },

      '&:disabled': {
        background: theme.accent.a1,
        opacity: 1,
      },
    },

    '&.MuiButton-warningPrimary': {
      '.MuiCircularProgress-root.MuiCircularProgress-indeterminate': {
        color: theme.primary.p2,
      },

      '&:disabled': {
        background: theme.accent.a4,
        opacity: 1,
      },
    },
  },
  loader: {
    width: 18,
    color: theme.primary.p2,
  },
  iconLeft: {
    ...dFlex(),
    marginRight: 4,

    '& img': {
      width: 20,
      height: 20,
    },
  },
  iconRight: {
    ...dFlex(),
    marginLeft: 4,

    '& img': {
      width: 20,
      height: 20,
    },
  },
  content: {
    ...dFlex('initial', 'initial'),
  },
  children: {
    ...dFlex(),
    textWrap: 'nowrap',
  },
}));

export default useStyles;
